var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "170px"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "95%",
      "margin": "0 2%",
      "margin-top": "20px"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "height": "30px",
      "width": "25%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("社保编号：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入社保编号",
      "size": "small"
    },
    model: {
      value: (_vm.from.social_security_no),
      callback: function($$v) {
        _vm.$set(_vm.from, "social_security_no", $$v)
      },
      expression: "from.social_security_no"
    }
  })], 2)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("医保编号：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入医保编号",
      "size": "small"
    },
    model: {
      value: (_vm.from.medical_insurance_no),
      callback: function($$v) {
        _vm.$set(_vm.from, "medical_insurance_no", $$v)
      },
      expression: "from.medical_insurance_no"
    }
  })], 2)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("保险类别：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择保险类别",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.insurance_type_id),
      callback: function($$v) {
        _vm.$set(_vm.from, "insurance_type_id", $$v)
      },
      expression: "from.insurance_type_id"
    }
  }, _vm._l((_vm.insuranceTypeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 2)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("五险参保开始月份：")])]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "placeholder": "请选择五险参保开始月份",
      "value-format": "yyyy-MM",
      "size": "small"
    },
    model: {
      value: (_vm.from.insured_begin_date),
      callback: function($$v) {
        _vm.$set(_vm.from, "insured_begin_date", $$v)
      },
      expression: "from.insured_begin_date"
    }
  })], 2)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("缴纳社保城市：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择缴纳社保城市",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.insured_city),
      callback: function($$v) {
        _vm.$set(_vm.from, "insured_city", $$v)
      },
      expression: "from.insured_city"
    }
  }, _vm._l((_vm.$globals.cityList), function(item) {
    return _c('el-option', {
      key: item.city,
      attrs: {
        "label": item.city,
        "value": item.city
      }
    })
  }), 1)], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("缴纳类别：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择缴纳类别",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.payment_type),
      callback: function($$v) {
        _vm.$set(_vm.from, "payment_type", $$v)
      },
      expression: "from.payment_type"
    }
  }, _vm._l((_vm.$globals.cityList), function(item) {
    return _c('el-option', {
      key: item.city,
      attrs: {
        "label": item.city,
        "value": item.city
      }
    })
  }), 1)], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("雇主出险记录：")])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": "",
      "size": "mini"
    }
  }, [_vm._v("出险记录")])], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("雇主出险状态：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small",
      "disabled": ""
    },
    model: {
      value: (_vm.from.entry_type),
      callback: function($$v) {
        _vm.$set(_vm.from, "entry_type", $$v)
      },
      expression: "from.entry_type"
    }
  })], 2)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("是否缴纳公积金：")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.from.is_accumulation_fund),
      callback: function($$v) {
        _vm.$set(_vm.from, "is_accumulation_fund", $$v)
      },
      expression: "from.is_accumulation_fund"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.from.is_accumulation_fund),
      callback: function($$v) {
        _vm.$set(_vm.from, "is_accumulation_fund", $$v)
      },
      expression: "from.is_accumulation_fund"
    }
  }, [_vm._v("否")])], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("公积金编号：")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入公积金编号",
      "size": "small"
    },
    model: {
      value: (_vm.from.accumulation_fund_no),
      callback: function($$v) {
        _vm.$set(_vm.from, "accumulation_fund_no", $$v)
      },
      expression: "from.accumulation_fund_no"
    }
  })], 2)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "48px",
      "font-size": "16px"
    }
  }, [_vm._v("缴纳月是否扣医保大额：")])]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择缴纳月是否扣医保大额",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.from.is_insurance_medical),
      callback: function($$v) {
        _vm.$set(_vm.from, "is_insurance_medical", $$v)
      },
      expression: "from.is_insurance_medical"
    }
  }, _vm._l((_vm.$globals.cityList), function(item) {
    return _c('el-option', {
      key: item.city,
      attrs: {
        "label": item.city,
        "value": item.city
      }
    })
  }), 1)], 2)], 1), _vm._v(" "), _c('td')])])])], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f950484a","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Ygxxlb/tabsEdit/insurance.vue
// module id = null
// module chunks = 